import USStates from 'src/components/Sales/USStates'
import ContactWorldSellers from './ContactWorldSellers'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { IReducer } from 'src/interface'

export default function USDealersFinder() {
  const dataContactReducer = useSelector((state: IReducer) => state.dataContactReducer)
  const [americaStateSelected, setAmericaStateSelected] = useState('none')
  const [americaStates, setStates] = useState(new Set<string>())
  const dealersByState = dataContactReducer.dealersAgents.domestic.filter((item) => {
    return item.states.includes(americaStateSelected)
  })

  useEffect(() => {
    setStatesList()
  }, [dataContactReducer])

  const setStatesList = () => {
    if (dataContactReducer.dealersAgents.domestic.length > 0 && americaStates.size === 0) {
      let states: Array<string> = []
      for (const iterator of dataContactReducer.dealersAgents.domestic) {
        states = states.concat(iterator.states)
      }
      setStates(new Set<string>(states))
    }
  }

  return (
    <>
      <USStates
        EEUUStates={americaStates}
        americaStateSelected={americaStateSelected}
        setAmericaStateSelected={setAmericaStateSelected}
      />
      {americaStateSelected !== 'none' &&
        dealersByState.map((dealer, index) => <ContactWorldSellers key={index} {...dealer} />)}
    </>
  )
}
